
import Component from 'vue-class-component'
import { Vue } from 'vue-property-decorator'
import { GeneralError } from '@/store/entities'
import ComponentLoadingSpinner from '@/commons/components/core/ComponentLoadingSpinner.vue'
import { DocumentService } from '@/store/services/document.service'
import { ApplicationService } from '@/store'
import { DocumentResponse } from '@/commons/types/document'

@Component({
    components: {
        ComponentLoadingSpinner
    }
})
export default class ValidDocuments extends Vue {
    validDocuments: Array<DocumentResponse> | null = []
    loadingInProgress = false

    async fetchValidDocuments (): Promise<void> {
        this.loadingInProgress = true
        try {
            this.validDocuments = await DocumentService.getValidDocuments()
        } catch {
            throw new GeneralError(['errors.system.title'])
        } finally {
            this.loadingInProgress = false
        }
    }

    getDocumentType (type: string): string {
        return DocumentService.getDocumentTypeAsString(type)
    }

    getExpiryDate (dateOfExpiry: string): string {
        return ApplicationService.formatJsonDate(dateOfExpiry)
    }

    mounted (): void {
        this.fetchValidDocuments()
    }
}
